import { Component, Input, ViewChild, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, } from '@angular/material/dialog';
import { DatePipe, DecimalPipe, ViewportScroller } from '@angular/common';
import {
  Observable,
  take,
  Subject,
  takeUntil,
  lastValueFrom,
  fromEvent,
  Subscription,
} from 'rxjs';
import { DialogFormFields } from 'src/app/shared/models/app-models/Dialog.model';
import { Store } from '@ngrx/store';
import { MatTableDataSource } from '@angular/material/table';
import VendorTypes from 'src/app/data/constants/VendorTypes.json';
import { MyPurchaseForm } from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { Vendor } from 'src/app/shared/models/database-models';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MatSidenav } from '@angular/material/sidenav';
import { SelectionModel } from '@angular/cdk/collections';
import { PageEvent } from '@angular/material/paginator';
import {
  AdvancedSearch,
  VendorSearchQuery,
} from 'src/app/shared/models/app-models/VendorSearchQuery.model';
import { addVendorsToMyPurchase, updateVendorsToMyPurchase } from 'src/app/core/store/form.actions';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import _ from 'lodash';
import { ActivatedRoute, Params } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AlertType } from 'src/app/shared/components/alert/alert.component';

export interface VendorSearchList {
  vendors: Vendor[];
  totalCount: number;
}

export interface VendorSearchDialogData {
  vendorActionType: string;
  routeParams: Params;
}

@Component({
  selector: 'app-vendor-search-dialog',
  templateUrl: './vendor-search-dialog.component.html',
  styleUrls: ['./vendor-search-dialog.component.scss'],
  providers: [
    {
      provide: DatePipe,
    },
    {
      provide: DecimalPipe,
    },
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class VendorSearchDialogComponent {
  readonly stepperLabels = {
    SELECT_VENDORS: "Select vendors",
    INPUT_JUSTIFICATION: "Input justification"
  }
  vendorActionType: string = '';
  vendorSearchInput: string = '';
  isAdvancedSearch: boolean = false;
  vendorSelection: SelectionModel<Vendor> = new SelectionModel<Vendor>(
    true,
    []
  );
  vendorForm: Vendor[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();
  duplicateFound: boolean = false
  //#region table declarations
  //vendor table
  vendorColumns = [
    {
      columnDef: 'Name',
      header: 'Vendor name',
      cell: (element: Vendor) => `${element.Name}`,
    },
    {
      columnDef: 'VendorContactPersonFullName',
      header: 'Contact person',
      cell: (element: Vendor) => `${element.VendorContactPersonFullName || ''}`,
    },
    {
      columnDef: 'VendorNumber',
      header: 'Vendor no.',
      cell: (element: Vendor) => `${element.VendorNumber}`,
    },
    {
      columnDef: 'AddressCountryCode',
      header: 'Country',
      cell: (element: Vendor) => `${element.AddressCountryCode}`,
    },
    {
      columnDef: 'EmailAddress',
      header: 'Email',
      cell: (element: Vendor) => `${element.EmailAddress ?? ''}`,
    },
    {
      columnDef: 'VendorStatus',
      header: 'Vendor status',
      cell: (element: Vendor) =>
        `${element.VendorStatus == null || element.VendorStatus == undefined
          ? ''
          : element.VendorStatus
        }`,
    },
  ];
  vendorDataSource: MatTableDataSource<Vendor> = new MatTableDataSource<Vendor>(
    []
  );
  pageSizeOptions: number[] = [5, 10, 20, 50];
  pageSize: number = 5;
  currentPage: number = 0;
  currentPageAdvance: number = 0;
  totalCount: number = 0;
  itemNo: number | null = null;
  advancedSearchValues!: AdvancedSearch;
  searchDisplayedCols: string[] = [
    'sSelect',
    'Name',
    'VendorContactPersonFullName',
    'VendorNumber',
    'AddressCountryCode',
    'EmailAddress',
    'VendorStatus',
    'IsPerm'
  ];
  advancedSearchForm!: FormGroup;
  purchaseType: string = '';
  isErrorJustification: boolean = false;
  form!: MyPurchaseForm;
  constructor(
    private store: Store<{ form: MyPurchaseForm }>,
    private BackendApi: BackendApiService,
    private dialog: MatDialog,
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<VendorSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VendorSearchDialogData
  ) {
    this.vendorActionType = data.vendorActionType;
    
    this.itemNo = parseInt(data.routeParams['itemNo'])

    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        this.vendorForm = form.VendorsToSource;
        this.form = form
      });

    this.purchaseType = data.routeParams['purchaseType'].split(
      ';'
    )[0] as string;
    /*if (this.purchaseType === 'tender' || this.purchaseType === 'dc') {
      this.tableAddJustification();
    }*/
    this.advancedSearchForm = this._fb.group({
      query: null,
      country: null,
      vendorType: null,
      city: null,
      vendorStatus: null,
      mainMaterialGroup: null,
      materialGroup: null,
      brand: null,
    });
  }

  async basicSearch() {
    try {
      let data = await this.basicSearchHelper(
        (this.currentPage + 1).toString(),
        this.pageSize.toString()
      );
      this.vendorDataSource.data = data.vendors;
      this.totalCount = data.totalCount;
    } catch (e) {
      console.log('error retrieving due to ', e);
    }
  }
  async basicSearchHelper(page: string, limit: string) {
    try {
      let query = this.vendorSearchInput;
      let searchQuery: VendorSearchQuery = {
        query: query,
        advanced: null,
      };
      return await lastValueFrom(
        this.BackendApi.searchVendors(searchQuery, page, limit)
      );
    } catch (e) {
      throw Error('Backend problem');
    }
  }

  resetDialogForm(dynamicForm: FormGroup) {
    dynamicForm.reset();
  }

  openAdvSearchDialog(): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      // height: '85%',
      // width: '60%',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Advanced Search',
        btnNameOne: 'Search',
        btnNameTwo: 'Reset',
        click: async () => {
          const values = this.advancedSearchForm.getRawValue();
          let queryData: AdvancedSearch = {
            query: values.query ?? null,
            country: values.country ? values.country.id : null,
            city: values.citySearch == '' ? null : values.citySearch,
            vendorType: values.vendorType ? values.vendorType.Id : null,
            vendorStatus: values.vendorStatus
              ? values.vendorStatus.Value
              : null,
            mainMaterialGroup: values.mainMaterialGroup
              ? values.mainMaterialGroup.id
              : null,
            materialGroup: values.materialGroup
              ? values.materialGroup.id
              : null,
            brand: values.brand ? values.brand.id : null,
          };
          console.log(queryData);
          this.advancedSearchValues = queryData;
          await this.advancedSearch();
          dialogRef.close();
        },
        clickTwo: () => this.advancedSearchForm.reset(),
        isForm: true,
        vendorInput: this.vendorSearchInput,
        formControl: this.advancedSearchForm,
      },
    });
  }
  async advancedSearch() {
    this.vendorSelection.clear();
    this.isAdvancedSearch = true;
    try {
      let data = await this.advancedSearchHelper(
        (this.currentPageAdvance + 1).toString(),
        this.pageSize.toString()
      );
      this.vendorDataSource.data = data.vendors;
      this.totalCount = data.totalCount;
    } catch (e) {
      console.log('error retrieving due to ', e);
    }
  }

  async advancedSearchHelper(page: string, limit: string) {
    try {
      let searchQuery: VendorSearchQuery = {
        query: null,
        advanced: this.advancedSearchValues,
      };
      return await lastValueFrom(
        this.BackendApi.searchVendors(searchQuery, page, limit)
      );
    } catch (e) {
      throw Error('Backend problem');
    }
  }
  async onSearchPageChange(event: PageEvent) {
    // this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    if (this.isAdvancedSearch) {
      this.currentPageAdvance = event.pageIndex;
      await this.advancedSearch();
    } else {
      this.currentPage = event.pageIndex;
      await this.basicSearch();
    }

    this.vendorDataSource.data.forEach((vendor) => {
      const found = this.vendorSelection.selected.find(
        (v) => v.VendorNumber == vendor.VendorNumber
      );
      if (found) {
        this.vendorSelection.deselect(found);
        this.vendorSelection.select(vendor);
      }
    });
  }

  masterVToggle() {
    if (this.isAllVSelected()) {
      this.vendorSelection.clear();
    } else {
      this.vendorDataSource.data.forEach((row) => {
        if (!this.isDisabled(row))
          this.vendorSelection.select(row)
      }
      );
    }
  }

  // function to check if all checkboxes are checked
  isAllVSelected() {
    const numSelected = this.vendorSelection.selected.length;
    const numRows = this.vendorDataSource.data.filter(x => !this.isDisabled(x)).length;
    return numSelected === numRows;
  }

  isVselected() {
    if (this.vendorSelection.selected.length !== 0) return true;
    return false;
  }

  isDisabled(element: Vendor) {
    if (element.VendorStatus == 'Suspended' || element.VendorStatus == 'Inactive' || element.VendorStatus == 'Deleted' || element.VendorStatus == 'Banned')
      return true
    else if (!element.IsPerm && !(this.purchaseType == 'corporatecard')) {
      return true
    }
    return false
  }

  // checkbox toggling
  onCheckboxChange($event: any, row: any) {
    $event ? this.vendorSelection.toggle(row) : null;
  }

  addVendor() {
    const dups = this.vendorDuplicateCheck(this.vendorSelection.selected);
    if (dups.length !== 0) {
      this.duplicateFound = true
      return;
    }

    for (const newVendor of this.vendorSelection.selected) {
      if (
        this.vendorForm.find(
          (v) => v.VendorNumber == newVendor.VendorNumber && !v.isDeleted && !v.Strikethrough
        )
      ) {
        console.log('Duplicate Vendors detected!');
        this.duplicateFound = true
        return;
      }
    }

    this.duplicateFound = false

    if (
      (this.purchaseType === 'tender' || this.purchaseType === 'dc') &&
      this.vendorCheckNoJustification(this.vendorSelection.selected)
    ) {
      this.isErrorJustification = true;
      return;
  }
    let vendorToAdd = this.vendorSelection.selected.map((vendor) => ({
      ...vendor,
      EmailAddress: vendor.EmailAddress && vendor.EmailAddress !== '-' ? vendor.EmailAddress : null,
      VendorContactPerson: vendor.VendorContactPerson && vendor.VendorContactPerson !== '-' ? vendor.VendorContactPerson : null,
      VendorContactPersonFullName: vendor.VendorContactPersonFullName && vendor.VendorContactPersonFullName !== '-' ? vendor.VendorContactPersonFullName : null,
      isDeleted: false,
      itemToTag: this.itemNo
    }));
    console.log("Before patch vendorActionType: ", this.vendorActionType)
    if (this.vendorActionType == 'itemVendor') {
      console.log("Add to item tag-vendor")
      this.store.dispatch(addVendorsToMyPurchase({ vendors: vendorToAdd }));
    } else {
      this.store.dispatch(addVendorsToMyPurchase({ vendors: vendorToAdd }));
    }
    this.vendorSelection.clear();
    this.dialogRef.close();
  }

  vendorDuplicateCheck(vendors: Vendor[]) {
    const counts = _.countBy(vendors, 'VendorNumber');
    return _.filter(vendors, (x) => counts[x.VendorNumber as any] > 1);
  }

  basicSearchClickHandler() {
    this.vendorSelection.clear();
    this.currentPage = 0;
    this.isAdvancedSearch = false;
    this.basicSearch();
  }

  vendorCheckNoJustification(vendors: Vendor[]) {
    return vendors.some((vendor: Vendor) => !vendor.Justification);
  }

  tableAddJustification() {
    this.searchDisplayedCols = [...this.searchDisplayedCols, 'Justification'];
    this.vendorColumns = [
      ...this.vendorColumns,
      {
        columnDef: 'Justification',
        header: 'Justification',
        cell: (element: Vendor) =>
          `${element.Justification == null || element.Justification == undefined
            ? ''
            : element.Justification
          }`,
      },
    ];
  }

  goCreateVendor() {
    const url = environment.mmscreateVendor;
    window.open(url, '_blank');
  }

  ACLASL() {
    const url = environment.mmsACL;
    window.open(url, '_blank');
  }

  public get alertType(): typeof AlertType {
    return AlertType;
  }

}
